export default class SortingOptions {
	orderBy;
	orderDir;

	constructor(orderBy = '', orderDir = 'asc') {
		this.orderBy = orderBy;
		this.orderDir = orderDir;
	}
}



// WEBPACK FOOTER //
// ./src/utils/domain/SortingOptions.js